module.exports = __webpack_public_path__ + "img/6543.474fdbe4.jpg";